// ** Icons Import
import { Home, Circle ,Grid} from 'react-feather'

export default [
  {
    id: 'dashboards',
    title: 'Home Page',
    icon: <Grid size={20} />,
    navLink: '/dashboard/analytics'
    // badge: 'light-warning',
    // badgeText: '2',
    // children: [
    //   {
    //     id: 'analyticsDash',
    //     title: 'Analytics',
    //     icon: <Circle size={12} />,
    //     navLink: '/dashboard/analytics'
    //   },
    //   {
    //     id: 'eCommerceDash',
    //     title: 'eCommerce',
    //     icon: <Circle size={12} />,
    //     navLink: '/dashboard/ecommerce'
    //   }
    // ]
  }
]
